<template>
  <div class="requirements__wrapper">
    <Accordion
      v-for="category in requirements"
      :id="category.tid"
      :key="category.tid"
      :full="full"
      :active="true"
      :dir-button="true"
      :dir-button-left="true"
      :title="category.categoryName"
      size="accordion-heading"
      class="requirements__body"
      level="requirement"
      @loadLicenses="accordionChange"
      @initiallyExpanded="initiallyExpandedAccordion"
    >
      <div
        v-for="topic in category.children"
        :key="topic.tid"
        class="requirements__inner"
      >
        <h2 class="heading">
          {{ topic.categoryName }}
        </h2>
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="hasAccess"
          v-html="externalLinks(topic.requirement.content)"
        />
        <!-- eslint-enable vue/no-v-html -->
        <div v-else class="unauthorised">{{ noAccessShort }}</div>
        <div v-if="topic.requirement.licenses.length > 0 && reports">
          <i
            >Relevant to:&nbsp;
            <span
              v-for="(license, lKey) in topic.requirement.licenses"
              :key="lKey"
            >
              {{ license
              }}{{ hasComma(lKey, topic.requirement.licenses.length) }}
            </span>
          </i>
        </div>
        <div v-for="(ref, index) in topic.requirement.references" :key="index">
          <a v-if="hasAccess" :href="ref.uri">{{ ref.title }}</a>
        </div>
        <!--<div>
          Last updated:
          <strong>{{ fixDate(topic.requirement.publishDate) }}</strong>
        </div>-->
        <RequirementHistory :requirements="topic.requirement.history" />
      </div>
    </Accordion>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { months } from "../../config";
import { links } from "../../mixin/links";
import { checkAccess, noAccessShort } from "@/utils/constants";
// import {links} from "@/mixin/links";

export default {
  name: "RequirementsReportList",
  components: {
    // TitleBlock: () => import("../elements/TitleBlock"),
    // Title: () => import("../elements/Title"),
    // Info: () => import("../elements/Info"),
    Accordion: () => import("../elements/Accordion"),
    RequirementHistory: () => import("../elements/RequirementHistory"),
  },
  mixins: [links],
  props: {
    jurisdiction: {
      type: Number,
      default: null,
    },
    requirements: {
      type: Array,
      default: null,
    },
    reports: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      months,
      noAccessShort,
      accessChecked: false,
    };
  },
  computed: {
    ...mapState("Auth", ["subscriptions"]),
    hasAccess(state) {
      const access =
        checkAccess(
          state.subscriptions.legacy_permissions,
          "viewRequirement"
        ) || checkAccess(state.subscriptions.permissions, "requirements");
      if (
        typeof window !== "undefined" &&
        window !== undefined &&
        window._paq &&
        !this.accessChecked
      ) {
        this.accessChecked = true;
        if (access === false) {
          window._paq.push([
            "trackEvent",
            "AccessDenied",
            "NoPermissions",
            this.$router.currentRoute.path,
            "",
          ]);
        }
      }
      return access;
    },
  },
  methods: {
    hasComma(i, l) {
      return i < l - 1 ? "," : "";
    },
    accordionChange(id, pid, jurisdictionParent, level) {
      this.trackRequirementView(id);
    },
    initiallyExpandedAccordion(id, pid, jurisdictionParent, level) {
      this.trackRequirementView(id);
    },
    trackRequirementView(id) {
      if (this.$matomo) {
        this.requirements.forEach((category) => {
          if (category.tid === id) {
            const concatNids = category.children
              .map((child) => child.requirement.nid)
              .join(",");
            this.$matomo.trackEvent("RequirementView", "View", concatNids);
            if(this.$churnZero) {
              this.$churnZero.trackEvent("RequirementView", "View");
            }
          }
        });
      }

    },
    // externalLinks(text) {
    //   const search = '<a ';
    //   const replaceWith = '<a target="_blank" ';
    //   const result = text.split(search).join(replaceWith);
    //   return result;
    // },
    fixDate(val) {
      let date = "";
      if (val) {
        const text = val.trim();
        const newText = text.substring(0, 10).replace(/-/g, "/");
        const newDate = new Date(newText);
        const day = newDate.getDate();
        const month = newDate.getMonth();
        const year = newDate.getFullYear();
        const monthName = this.months.find((el) => el.id === month);
        if (monthName) {
          date =
            (day < 10 ? `0${day}` : day) +
            " " +
            (this.min ? monthName.shortname : monthName.name) +
            " " +
            year;
        }
      }
      return date;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.requirements {
  &__wrapper {
    // margin-left: 2rem;
  }

  &__body {
    // padding-top: 3rem;
    // margin-left: 3rem;

    .heading {
      font-size: 2.2rem;
      font-weight: bold;
    }
  }

  &__inner {
    // padding-top: 3rem;
    padding-left: 3rem;
    border-left: dotted 1px $border;
    padding-top: 3rem;

    .heading {
      font-size: 1.8rem;
      font-weight: 700;
    }
  }
}
</style>
